import http from "./http";

/* =======================
   ADD SUB CATEGORY
======================= */
export const addSubCategory = async (payload) => {
  const res = await http.post("sub_category_api", {
    action: "add",
    category_id: payload.category_id,
    sub_category_name: payload.sub_category_name,
  });
  return res.data;
};

/* =======================
   GET ALL
======================= */
export const getSubCategories = async () => {
  const res = await http.post("sub_category_api", {
    action: "get",
  });
  return res.data;
};

/* =======================
   DELETE
======================= */
export const deleteSubCategory = async (id) => {
  const res = await http.post("sub_category_api", {
    action: "delete",
    id,
  });
  return res.data;
};

/* =======================
   ✅ GET SINGLE (EDIT)
   API: single-sub-cat
======================= */
export const getSubCategoryById = async (id) => {
  const res = await http.post("single-sub-cat", {
    action: "get",
    id,
  });
  return res.data;
};

/* =======================
   UPDATE
======================= */
export const updateSubCategory = async (id, payload) => {
  const res = await http.post("sub_category_api", {
    action: "update",
    id,
    category_id: payload.category_id,
    sub_category_name: payload.sub_category_name,
  });
  return res.data;
};
